(() => {
  const enhanceContribe = () => {
    const selector = document.querySelector('#contribe-selector');
    if (!selector) return;

    // The app currently injects a second <main>. An explicit labelled region prevents a
    // duplicate-main landmark without rewriting app-owned DOM.
    selector.setAttribute('role', 'region');
    selector.setAttribute('aria-label', 'Vælg donationsprojekt');

    selector.querySelectorAll('button').forEach((button, index) => {
      const hasName = button.getAttribute('aria-label')
        || button.getAttribute('aria-labelledby')
        || button.textContent.trim();
      if (hasName) return;

      const mediaName = button.querySelector('img[alt]')?.alt?.trim()
        || button.querySelector('[title]')?.getAttribute('title')?.trim();
      button.setAttribute('aria-label', mediaName || `Vælg donationsprojekt ${index + 1}`);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceContribe, { once: true });
  } else {
    enhanceContribe();
  }

  const observer = new MutationObserver(enhanceContribe);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
